export default __webpack_public_path__ + "static/media/P4.73c725b4.png";